import React from "react"
import { Link } from "react-router-dom";
import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from "@mui/icons-material/Person";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faKey} from "@fortawesome/free-solid-svg-icons";

const MyProfile = (props) => {

    const logout = () => {
        localStorage.clear();
        window.location.replace('/login');
    }

    return (
        <nav
            ref={props.dropdownRef}
            className={`my-profile ${props.isActive ? "active" : "inactive"}`}
        >
            <div className="my-profile_list">
                <Link to='/hms/myAccount'><PersonIcon className="mx-0 pl-0"/> My Account</Link>
                <Link to='/hms/changePassword'><FontAwesomeIcon icon={faKey} className="" /> Change Password</Link>
                <p onClick={logout}> <LogoutIcon className="mx-0 pl-0"/> Logout</p>
            </div>
        </nav>
    )
}


export default MyProfile